export default "__VITE_ASSET__IXEi5B29__"